import { createFileRoute } from '@tanstack/react-router';

import { CompanyRolesPage } from '@/pages/super-admin/company-roles/CompanyRolesPage';

export const Route = createFileRoute('/_authenticated/super-admin/companies/$companyId_/roles')({
	component: CompanyRolesRoute,
});

function CompanyRolesRoute() {
	const { companyId } = Route.useParams();
	return <CompanyRolesPage companyId={companyId} />;
}
